/* pm-cart-page.js — lógica de Cartão x PIX/Boleto, só na página /cart.
   Escuta o evento nativo "afterUpdateQuantity" que o cart.js da
   Woodstock já dispara sozinho — não sobrescreve nada do tema. */
(function () {
  'use strict';

  const METHOD_LABELS = {
    cartao: { name: 'Cartão de Crédito', extra: ' (Parcelado sem juros)' },
    pix: { name: 'À Vista no PIX/Boleto', extra: ' (Com desconto)' },
  };

  function pmFormatBRL(cents) {
    return (Number(cents) / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  }

  function pmRecomputeTotals() {
    const pixTotalEl = document.getElementById('pix-price');
    const cartaoTotalEl = document.getElementById('cartao-price');
    if (!pixTotalEl || !cartaoTotalEl) return;

    let cartaoTotal = 0;
    let pixTotal = 0;
    document.querySelectorAll('.cart-item').forEach((row) => {
      cartaoTotal += Number(row.dataset.cartaoPrice || 0);
      pixTotal += Number(row.dataset.pixPrice || 0);
    });
    cartaoTotalEl.innerText = pmFormatBRL(cartaoTotal);
    pixTotalEl.innerText = pmFormatBRL(pixTotal);
  }

  function pmSyncCartStateFromDOM() {
    window.pmCartState = window.pmCartState || {};
    document.querySelectorAll('.cart-item').forEach((row) => {
      const qtyInput = row.querySelector('.quantity__input');
      if (row.dataset.varId && qtyInput) {
        window.pmCartState[row.dataset.varId] = Number(qtyInput.value || 0);
      }
    });
  }

  function pmGetSectionId() {
    return document.getElementById('main-cart-items')?.dataset.id;
  }

  function pmIsDiverseNow() {
    let hasCartao = false;
    let hasPix = false;
    document.querySelectorAll('.cart-item').forEach((row) => {
      if ((row.dataset.sku || '').includes('-2')) {
        hasCartao = true;
      } else {
        hasPix = true;
      }
    });
    return hasCartao && hasPix;
  }

  function pmShowSelectedMethod(method) {
    const label = METHOD_LABELS[method];
    const el = document.getElementById('pm-selected-method');
    if (!label || !el) return;
    el.innerHTML = 'Selecionado: <strong>' + label.name + '</strong>' + label.extra;
    el.classList.remove('hide');
  }

  function pmHandleMethodClick(event) {
    const method = event.currentTarget.id;
    const cartState = window.pmCartState || {};
    const updates = {};
    const wasDiverse = pmIsDiverseNow();

    document.querySelectorAll('.cart-item').forEach((row) => {
      const quantityInput = row.querySelector('.quantity__input');
      const quantity = Number(quantityInput ? quantityInput.value : 0);
      const sku = row.dataset.sku || '';
      const variantId = row.dataset.varId;
      const altId = row.dataset.altId;

      const isCartaoRow = sku.includes('-2');
      const rowMatchesChosenMethod = method === 'cartao' ? isCartaoRow : !isCartaoRow;

      if (!rowMatchesChosenMethod) {
        updates[variantId] = 0;
        updates[altId] = wasDiverse ? (cartState[altId] || 0) + quantity : quantity;
      }
    });

    const sectionId = pmGetSectionId();

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates, sections: sectionId ? [sectionId] : [] }),
    })
      .then((response) => response.json())
      .then((result) => {
        if (sectionId && result.sections && result.sections[sectionId]) {
          const parsedHtml = new DOMParser().parseFromString(result.sections[sectionId], 'text/html');

          const newItemsHtml = parsedHtml.querySelector('.js-contents');
          const currentItemsWrap = document.querySelector('#main-cart-items .js-contents');
          if (newItemsHtml && currentItemsWrap) currentItemsWrap.innerHTML = newItemsHtml.innerHTML;

          const newFooterHtml = parsedHtml.querySelector('.cart__footer__js-contents');
          const currentFooterWrap = document.querySelector('#main-cart-footer .cart__footer__js-contents');
          if (newFooterHtml && currentFooterWrap) currentFooterWrap.innerHTML = newFooterHtml.innerHTML;
        }

        document.querySelector('.pm-diverse-alert')?.remove();
        document.querySelector('.cart__blocks.hide')?.classList.remove('hide');
        document.getElementById('pm-change-method')?.classList.remove('hide');
        pmShowSelectedMethod(method);

        pmSyncCartStateFromDOM();
        pmRecomputeTotals();
      })
      .catch((error) => console.error('pm-cart-page:', error));
  }

  function pmInit() {
    pmRecomputeTotals();
    pmSyncCartStateFromDOM();

    document.querySelectorAll('.pm-method').forEach((btn) => {
      btn.addEventListener('click', pmHandleMethodClick);
    });

    document.getElementById('pm-change-method')?.addEventListener('click', function () {
      this.classList.add('hide');
    });

    document.addEventListener('afterUpdateQuantity', () => {
      pmSyncCartStateFromDOM();
      pmRecomputeTotals();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pmInit);
  } else {
    pmInit();
  }
})();